import { WhiteSpaceKeys } from "../../dom-tools/keyboard-events/WhiteSpaceKeys";
import { TextEditorElementKeyEvent } from "./TextEditorElementKeyEvent";

export class DefaultTextTransformer
{
  static readonly $ = new DefaultTextTransformer();

  transformText( tke: TextEditorElementKeyEvent ) 
  {
    if ( WhiteSpaceKeys.Enter === tke.key )
    {
      return "\n";
    }

    if ( WhiteSpaceKeys.Tab === tke.key )
    {
      return "\t";
    }

    return tke.key;
  }
}